<template>
  <BaseDialog
    v-model:visible="visible"
    :title="$t('member.tab.beautyAI360Analysis.descTitle')"
    width="576px"
    @close="$emit('close')"
  >
    <div class="content">
      <p>{{ $t('member.tab.beautyAI360Analysis.descContent') }}</p>
      <br>
      <p>{{ $t('member.tab.beautyAI360Analysis.descContribution') }}</p>
      <p>{{ $t('member.tab.beautyAI360Analysis.descActivity') }}</p>
      <p>{{ $t('member.tab.beautyAI360Analysis.descPotential') }}</p>
      <p>{{ $t('member.tab.beautyAI360Analysis.descLoyalty') }}</p>
      <p>{{ $t('member.tab.beautyAI360Analysis.descDispersion') }}</p>
    </div>
  </BaseDialog>
</template>

<script>
import { defineComponent } from 'vue'
import BaseDialog from '@/components/Dialog/BaseDialog.vue'

export default defineComponent({
  name: 'Member3660AnalysisDescriptionModal',
  components: { BaseDialog },
  setup (props) {
    return {}
  },
})
</script>

<style lang="postcss" scoped>
.content {
    @apply mb-[32px] h-[324px] overflow-y-auto p-[12px] text-sub;
    @apply border border-gray-40 rounded-[4px];
    @apply flex flex-col gap-[8px];
}
</style>
